import React, { useState, useEffect } from "react";
import { saveJwtToken } from "../../hooks/fetchUtils";

// <Topis#RewriteableFunctionHeader> -- do not change the code below
export default function WebFaSolutionTestComponentPresenter({
  bankProxyServerConnectionParams,
  onBankProxyServerConnectionParamsPost,
  onBankProxyServerConnectionParamsClear,
  ...props
}) {
  // </Topis#RewriteableFunctionHeader> -- do not change the code above

  const [phoneNumber, setPhoneNumber] = useState("");
  const [tokenLifetime, setTokenLifetime] = useState(12); // Default value of 12 hours
  const [serverResponse, setServerResponse] = useState(null);
  const [tokenSavedMessage, setTokenSavedMessage] = useState("");

  const handlePhoneInputChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleTokenLifetimeChange = (e) => {
    setTokenLifetime(Number(e.target.value));
  };

  const handleSubmit = () => {
    if (!phoneNumber) {
      alert("Please enter your phone number");
      return;
    }
    const phoneDto = { phoneNumber, hours: tokenLifetime };

    onBankProxyServerConnectionParamsPost(
      phoneDto,
      (response) => {
        setServerResponse(response);
      },
      (error) => {
        console.error("Error fetching data:", error);
        alert("Failed to fetch data. Please try again later.");
      },
      () => {
        console.log("Request cancelled");
      }
    );
  };

  useEffect(() => {
    if (serverResponse && serverResponse.accessToken) {
      saveJwtToken(serverResponse.accessToken);
      setTokenSavedMessage("Token saved successfully!");
    }
  }, [serverResponse]);

  return (
    <div className="container-lg">
      <div className="h4">
        Получить параметры доступа к серверу и записать токен в sessionStorage
        для использования в запросах
      </div>

      <div className="form-group">
        <label htmlFor="phoneInput">Enter your phone number:</label>
        <input
          type="text"
          id="phoneInput"
          className="form-control"
          value={phoneNumber}
          onChange={handlePhoneInputChange}
        />
      </div>

      <div className="form-group">
        <label htmlFor="tokenLifetimeInput">Token Lifetime (hours):</label>
        <input
          type="number"
          id="tokenLifetimeInput"
          className="form-control"
          value={tokenLifetime}
          onChange={handleTokenLifetimeChange}
          min="1"
        />
      </div>

      <button className="btn btn-primary" onClick={handleSubmit}>
        Submit
      </button>

      {serverResponse && (
        <div className="mt-3">
          <h5>Server Response:</h5>
          <pre>{JSON.stringify(serverResponse, null, 2)}</pre>
        </div>
      )}

      {tokenSavedMessage && (
        <div className="alert alert-success mt-3">{tokenSavedMessage}</div>
      )}
    </div>
  );
}
